import SwapVert from "@mui/icons-material/SwapVert";
import * as React from "react";

import { MprcIconSvg, MprcIconSvgProps } from "../MprcIconSvg";

type Props = Omit<MprcIconSvgProps, "icon">;

export const IconSort: React.FunctionComponent<Props> = (props) => {

    return <MprcIconSvg {...props} icon={SwapVert} />;
};
